import React, {useEffect, useState} from "react";
import {Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Button } from 'antd';
import {useDispatch, useSelector} from "react-redux";
import { selectUser } from "../../redux/features/userSlice";
import {basePath} from "../../config";
import {ROUTES as ROUTES_CONFIG} from "../../config/constants";

const selector = useSelector

const MenuNav = ({OnSale, accountPage, securityPage}) => {

    let GetUser = selector(selectUser);
    let ActiveMenu = useSelector ((state) => state.menu.ActiveMenu)

    const location = useLocation();
    const dispatch = useDispatch()

    let FrontLogin = useSelector(state => state.metahut.FrontLogin)

    useEffect(() => {

        const currentURL = window.location.href        

        if (GetUser && GetUser.profile_complete==0 && GetUser.user_type==1 && currentURL.indexOf(securityPage) === -1 ) {
            console.log('securityPage need to redirect');
             // navigate(securityPage)
        }

        if (GetUser && GetUser.profile_complete==0 && GetUser.user_type==2 && currentURL.indexOf(accountPage) === -1 ) {
            console.log('accountPage need to redirect');
            // navigate(accountPage)
        }

    }, [GetUser])

    const switchMenu = () => {

        if(location.pathname.toString().includes("/metahuts")) {
            dispatch({type: 'setActiveMenu', payload: false})
        } else if (location.pathname.toString().includes("/admin")) {
            dispatch({type: 'setActiveMenu', payload: true})
        } else {
            dispatch({type: 'setActiveMenu', payload: false})
        }
    }


    useEffect(() => {

        switchMenu();

    }, [location, location.pathname])


    return (
        <>
            {location.pathname == '/login' || location.pathname == '/register' ? '' :
                <div className={`text-2xl menu-active bg-${location.pathname == '/' ? 'transparent' : 'indigo-800'}`}>
                    <div className="container mx-auto px-8 pr-4 flex items-center justify-between gap-x-2">
                        <div className="flex items-center gap-x-6 menu-nav visible-lg">
                            <NavLink to={ROUTES_CONFIG.discoveryOverview.path} className="text-gray-light pb-2 font-mont">Discovery</NavLink>
                            
                            {/* {GetUser && GetUser.is_admin == 1 ? */}
                                <NavLink to={ROUTES_CONFIG.events.path} className="text-gray-light pb-2 font-mont">Events</NavLink>
                            {/* :''} */}
                            {/*<NavLink to={ROUTES_CONFIG.marketplace.path} className="text-gray-light pb-2 font-mont">Marketplace</NavLink>*/}
                            <NavLink to={ROUTES_CONFIG.home.path} className="text-gray-light pb-2 font-mont">Map</NavLink>
                            <NavLink to={ROUTES_CONFIG.staking.path} className="text-gray-light pb-2 font-mont">Staking</NavLink>
                            <a href="https://metafluence.gitbook.io/docs/" target="_blank" className="text-gray-light pb-2 font-mont">Docs</a>
                            {/*<NavLink to={ROUTES_CONFIG.myNFTs.path} className="text-gray-light pb-2 font-mont">My PublicLands</NavLink>*/}

                            {/* <NavLink to="/metahuts/mycollection" className={`text-gray-light pb-2 font-mont ${ActiveMenu ? 'active' : ''}`}>Get Metahut</NavLink> */}

                            {/*<NavLink to={ROUTES_CONFIG.newMetahut.path} className="text-gray-light pb-2 font-mont">Get Metahut</NavLink>*/}

                            {/*{GetUser && (GetUser.user_type==1 || GetUser.profile_complete == 1) ?*/}
                            {/*    <NavLink to={ROUTES_CONFIG.adminMetahutRooms.path} className={`text-gray-light pb-2 font-mont`}>My Metahuts</NavLink>*/}
                            {/*: ''}*/}
 
                            {/*<NavLink to={ROUTES_CONFIG.fag.path} className="text-gray-light pb-2 font-mont">FAQ</NavLink>*/}

                            {GetUser &&  GetUser.id ?
                                <> 
                                    <div className="menu-y"></div>
                                    <NavLink to={ROUTES_CONFIG.profile.path} className={`text-gray-light pb-2 font-mont`}>Profile</NavLink>
                                    <NavLink to={ROUTES_CONFIG.referralLink.path} className={`text-gray-light pb-2 font-mont`}>Referrals</NavLink>
                                </>
                            : ''}

                            {GetUser && GetUser.is_admin == 1 ?
                               <>
                                <NavLink to={ROUTES_CONFIG.quiz.path} className="text-gray-light pb-2 font-mont">Quiz</NavLink>
                                <NavLink to={ROUTES_CONFIG.adminMetahutRooms.path} className="text-gray-light pb-2 font-mont">Metahuts</NavLink>
                               </>
                               : ''
                            }


                        </div>


                        <div className="flex items-center justify-end gap-x-4 flex-1">
                            <div className="flex items-center" id="onsalearea" style={{display: OnSale && document.location.pathname==basePath ? "" : "none"}}>
                                <Button type="primary" id="onsaleareaclick" className="uppercase text-sm border-0 bg-cyan-500 text-indigo-900 hover:bg-cyan-400 rounded-md">On sale</Button>
                            </div>
                        </div>

                    </div>
                </div>
            }
        </>
    )
}

export default MenuNav;